import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import api from '../../services/api';
import { useAuth } from '../../context/AuthContext';
import TCLogo from '../auth/TCLogo';

const AdminLogin = () => {
  const navigate = useNavigate();
  const { loginUser } = useAuth();
  const [form, setForm] = useState({ email: '', password: '' });
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError('');
    setLoading(true);
    try {
      const res = await api.post('/auth/admin-login', { email: form.email, password: form.password });
      const { accessToken, refreshToken, user } = res.data;
      if (user.role !== 'platform_admin') {
        return setError('Access denied. Platform Admin only.');
      }
      loginUser(user, { slug: 'admin' }, accessToken, refreshToken);
      navigate('/admin/dashboard');
    } catch (err) {
      setError(err.response?.data?.error || 'Login failed');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div style={{minHeight:'100vh',display:'flex',flexDirection:'column',alignItems:'center',justifyContent:'center',background:'linear-gradient(135deg, #1B3A5C 0%, #7D6608 100%)',padding:'20px'}}>
      <div style={{background:'white',borderRadius:'12px',padding:'40px',width:'100%',maxWidth:'420px',boxShadow:'0 20px 60px rgba(0,0,0,0.3)'}}>
        <div style={{textAlign:'center',marginBottom:'32px'}}>
          <TCLogo size={64} />
          <h1 style={{fontSize:'26px',fontWeight:'700',color:'#1B3A5C',marginTop:'12px',marginBottom:'4px'}}>CONSAM</h1>
          <p style={{color:'#595959',fontSize:'13px',marginBottom:'8px'}}>Platform Administration</p>
          <div style={{display:'inline-block',background:'#FEF9E7',color:'#7D6608',padding:'4px 14px',borderRadius:'20px',fontSize:'11px',fontWeight:'700',letterSpacing:'1px'}}>
            PLATFORM ADMIN
          </div>
        </div>
        <form onSubmit={handleSubmit}>
          <div className="form-group">
            <label>Email Address</label>
            <input type="email" value={form.email}
              onChange={e => setForm({...form, email: e.target.value})}
              placeholder="Platform admin email" required autoFocus />
          </div>
          <div className="form-group">
            <label>Password</label>
            <input type="password" value={form.password}
              onChange={e => setForm({...form, password: e.target.value})}
              placeholder="Enter password" required />
          </div>
          {error && <p className="error-msg">{error}</p>}
          <button type="submit" className="btn btn-primary"
            style={{width:'100%',padding:'12px',fontSize:'15px',marginTop:'8px',background:'#7D6608'}}
            disabled={loading}>
            {loading ? 'Signing in...' : 'Sign In'}
          </button>
        </form>
      </div>
      <p style={{color:'rgba(255,255,255,0.5)',fontSize:'11px',marginTop:'20px'}}>
        © 2026 CONSAM. Restricted Access.
      </p>
    </div>
  );
};

export default AdminLogin;
